import { render, staticRenderFns } from "./SubmitCard.vue?vue&type=template&id=1187e58a&functional=true"
import script from "./SubmitCard.vue?vue&type=script&lang=js"
export * from "./SubmitCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports